import React, { useState, useEffect, useRef } from "react";
import "../css/our-culture.css";
import "../css/team.css";
import diwalibanner from "../img/Culture/Diwalibanner.jpeg";
import lohribanner from "../img/Culture/lohribanner.jpeg";
import lohriimg1 from "../img/Culture/lohri/lohri1.jpeg";
import lohriimg2 from "../img/Culture/lohri/lohri2.jpeg";
import holibanner from "../img/Culture/holibanner.jpeg";
import cricketbanner from "../img/Culture/cricketbanner.jpeg";
import cricket1 from "../img/Culture/cricket/cricket1.jpeg";
import cricket2 from "../img/Culture/cricket/cricket2.jpeg";
import diwaliimg1 from "../img/Culture/diwali/img1.jpeg";
import diwaliimg2 from "../img/Culture/diwali/img2.jpeg";
import diwaliimg3 from "../img/Culture/diwali/img3.jpeg";
import diwaliimg4 from "../img/Culture/diwali/img4.jpeg";
import diwaliimg5 from "../img/Culture/diwali/img5.jpeg";
import diwaliimg6 from "../img/Culture/diwali/img6.jpeg";
import diwaliimg7 from "../img/Culture/diwali/img7.jpeg";
import diwaliimg8 from "../img/Culture/diwali/img8.jpeg";
import diwaliimg9 from "../img/Culture/diwali/img9.jpeg";
import diwaliimg10 from "../img/Culture/diwali/img10.jpeg";
import diwaliimg11 from "../img/Culture/diwali/img11.jpeg";
import birthdaybanner from "../img/Culture/birthdaybanner.jpeg";
import birthday1 from "../img/Culture/birthday/birthday1.jpeg";
import birthday2 from "../img/Culture/birthday/birthday2.jpeg";
import appreciationbanner from "../img/Culture/appreciationbanner.jpeg";
import appreciation2 from "../img/Culture/Appreciation/appreciation2.jpeg";
import appreciation3 from "../img/Culture/Appreciation/appreciation3.jpeg";

function OurCulture() {
  const [selectedImage, setSelectedImage] = useState(null);
  const [isGalleryOpen, setIsGalleryOpen] = useState(false);
  const [selectedFestival, setSelectedFestival] = useState(null);
  const [activeCategory, setActiveCategory] = useState("all");
  const modalGalleryRef = useRef(null);

  const scrollModalGallery = (direction) => {
    const slider = modalGalleryRef.current;
    if (!slider) return;
    
    const scrollAmount = 500; // Adjust based on card width + gap
    if (direction === 'left') {
      slider.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    } else {
      slider.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);

    // Scroll animation observer
    const observerOptions = {
      threshold: 0.1,
      rootMargin: "0px 0px -50px 0px",
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("visible");
        }
      });
    }, observerOptions);

    // Observe all sections
    const sections = document.querySelectorAll(".section-block");
    sections.forEach((section) => observer.observe(section));

    // Keyboard navigation for gallery
    const handleKeyDown = (e) => {
      if (!isGalleryOpen) return;
      
      switch(e.key) {
        case 'ArrowLeft':
          navigateImage("prev");
          break;
        case 'ArrowRight':
          navigateImage("next");
          break;
        case 'Escape':
          closeGallery();
          break;
        default:
          break;
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      sections.forEach((section) => observer.unobserve(section));
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [isGalleryOpen, selectedFestival, selectedImage]);

  const festivalImages = {
    diwali: [
      {
        id: "diwali-1",
        src: diwalibanner,
        thumbnail: diwalibanner,
        alt: "Diwali celebration with lights",
        title: "Diwali Festival - Festival of Lights",
        description:
          "Celebrating the victory of light over darkness with our team",
      },
      {
        id: "diwali-2",
        src: diwaliimg1,
        thumbnail: diwaliimg1,
        alt: "Diwali celebration part 2",
        title: "Diwali Festival - Team Celebration",
        description: "Team members enjoying the festive spirit",
      },
      {
        id: "diwali-3",
        src: diwaliimg2,
        thumbnail: diwaliimg2,
        alt: "Diwali celebration part 2",
        title: "Diwali Festival - Team Celebration",
        description: "Team members enjoying the festive spirit",
      },
      {
        id: "diwali-4",
        src: diwaliimg3,
        thumbnail: diwaliimg3,
        alt: "Diwali celebration part 2",
        title: "Diwali Festival - Team Celebration",
        description: "Team members enjoying the festive spirit",
      },
      {
        id: "diwali-5",
        src: diwaliimg4,
        thumbnail: diwaliimg4,
        alt: "Diwali celebration part 2",
        title: "Diwali Festival - Team Celebration",
        description: "Team members enjoying the festive spirit",
      },
      {
        id: "diwali-6",
        src: diwaliimg5,
        thumbnail: diwaliimg5,
        alt: "Diwali celebration part 2",
        title: "Diwali Festival - Team Celebration",
        description: "Team members enjoying the festive spirit",
      },
      {
        id: "diwali-7",
        src: diwaliimg6,
        thumbnail: diwaliimg6,
        alt: "Diwali celebration part 2",
        title: "Diwali Festival - Team Celebration",
        description: "Team members enjoying the festive spirit",
      },
      {
        id: "diwali-8",
        src: diwaliimg7,
        thumbnail: diwaliimg7,
        alt: "Diwali celebration part 2",
        title: "Diwali Festival - Team Celebration",
        description: "Team members enjoying the festive spirit",
      },
      {
        id: "diwali-9",
        src: diwaliimg8,
        thumbnail: diwaliimg8,
        alt: "Diwali celebration part 2",
        title: "Diwali Festival - Team Celebration",
        description: "Team members enjoying the festive spirit",
      },
      {
        id: "diwali-10",
        src: diwaliimg9,
        thumbnail: diwaliimg9,
        alt: "Diwali celebration part 2",
        title: "Diwali Festival - Team Celebration",
        description: "Team members enjoying the festive spirit",
      },
      {
        id: "diwali-11",
        src: diwaliimg10,
        thumbnail: diwaliimg10,
        alt: "Diwali celebration part 2",
        title: "Diwali Festival - Team Celebration",
        description: "Team members enjoying the festive spirit",
      },
      {
        id: "diwali-12",
        src: diwaliimg11,
        thumbnail: diwaliimg11,
        alt: "Diwali celebration part 2",
        title: "Diwali Festival - Team Celebration",
        description: "Team members enjoying the festive spirit",
      },
    ],
    holi: [
      {
        id: "holi-1",
        src: holibanner,
        thumbnail: holibanner,
        alt: "Holi celebration with colors",
        title: "Holi Festival - Colors of Joy",
        description:
          "Celebrating the festival of colors with team spirit and enthusiasm",
      },
      // Add more Holi images here
      // {
      //   id: 'holi-2',
      //   src: holiImage2,
      //   thumbnail: holiImage2,
      //   alt: "Holi celebration part 2",
      //   title: "Holi Festival - Team Celebration",
      //   description: "Team members enjoying the festive spirit"
      // }
    ],
    lohri: [
      {
        id: "lohri-1",
        src: lohribanner,
        thumbnail: lohribanner,
        alt: "Lohri celebration with bonfire",
        title: "Lohri Festival - Harvest Celebration",
        description:
          "Celebrating the harvest season with traditional bonfire and festivities",
      },
      {
        id: "lohri-2",
        src: lohriimg1,
        thumbnail: lohriimg1,
        alt: "Lohri celebration part 2",
        title: "Lohri Festival - Community Gathering",
        description: "Team bonding during the harvest festival",
      },
      {
        id: "lohri-3",
        src: lohriimg2,
        thumbnail: lohriimg2,
        alt: "Lohri celebration part 3",
        title: "Lohri Festival - Community Gathering",
        description: "Team bonding during the harvest festival",
      },
    ],
    cricket: [
      {
        id: "cricket-1",
        src: cricketbanner,
        thumbnail: cricketbanner,
        alt: "Cricket tournament celebration",
        title: "Cricket Tournament - Sports Spirit",
        description:
          "Annual cricket tournament showcasing team sportsmanship and competitive spirit",
      },
      {
        id: "cricket-2",
        src: cricket1,
        thumbnail: cricket1,
        alt: "Cricket match highlights",
        title: "Cricket Tournament - Match Action",
        description: "Exciting moments from the cricket tournament",
      },
      {
        id: "cricket-3",
        src: cricket2,
        thumbnail: cricket2,
        alt: "Cricket match highlights",
        title: "Cricket Tournament - Match Action",
        description: "Exciting moments from the cricket tournament",
      },
    ],
    birthday: [
      {
        id: "birthday-1",
        src: birthdaybanner,
        thumbnail: birthdaybanner,
        alt: "Birthday celebration",
        title: "Birthday Celebration",
        description:
          "Celebrating team members' birthdays with joy and appreciation",
      },
      {
        id: "birthday-2",
        src: birthday1,
        thumbnail: birthday1,
        alt: "Birthday celebration",
        title: "Birthday Celebration",
        description: "Birthday celebration",
      },
      {
        id: "birthday-3",
        src: birthday2,
        thumbnail: birthday2,
        alt: "Birthday celebration",
        title: "Birthday Celebration",
        description: "Birthday celebration",
      },
    ],
    appreciation: [
      {
        id: "appreciation-1",
        src: appreciationbanner,
        thumbnail: appreciationbanner,
        alt: "Appreciation celebration",
        title: "Appreciation Celebration",
        description:
          "Annual appreciation celebration showcasing team spirit and achievements",
      },
      {
        id: "appreciation-2",
        src: appreciation2,
        thumbnail: appreciation2,
        alt: "Appreciation celebration",
        title: "Appreciation Celebration",
        description: "Appreciation celebration",
      },
      {
        id: "appreciation-4",
        src: appreciation3,
        thumbnail: appreciation3,
        alt: "Appreciation celebration",
        title: "Appreciation Celebration",
        description: "Appreciation celebration",
      },
    ],
  };

  // Main gallery display images (one from each festival)
  const galleryImages = [
    {
      id: "diwali-1",
      src: diwalibanner,
      thumbnail: diwalibanner,
      alt: "Diwali celebration",
      title: "Diwali Festival Celebration",
      color: "#1f66ff",
      festival: "diwali",
    },
    {
      id: "holi-1",
      src: holibanner,
      thumbnail: holibanner,
      alt: "Holi celebration",
      title: "Holi Festival Celebration",
      color: "#ff6584",
      festival: "holi",
    },
    {
      id: "lohri-1",
      src: lohribanner,
      thumbnail: lohribanner,
      alt: "Lohri celebration",
      title: "Lohri Festival Celebration",
      color: "#1fba68",
      festival: "lohri",
    },
    {
      id: "cricket-1",
      src: cricketbanner,
      thumbnail: cricketbanner,
      alt: "Cricket tournament",
      title: "Cricket Tournament",
      color: "#0f4c81",
      festival: "cricket",
    },
    {
      id: "birthday-1",
      src: birthdaybanner,
      thumbnail: birthdaybanner,
      alt: "Birthday celebration",
      title: "Birthday Celebration",
      color: "#ff6584",
      festival: "birthday",
    },
    {
      id: "appreciation-1",
      src: appreciationbanner,
      thumbnail: appreciationbanner,
      alt: "Appreciation celebration",
      title: "Appreciation Celebration",
      color: "#1fba68",
      festival: "appreciation",
    },
  ];

  const openGallery = (imageId, festival = null) => {
    setSelectedImage(imageId);
    setSelectedFestival(festival);
    setIsGalleryOpen(true);
  };

  const closeGallery = () => {
    setIsGalleryOpen(false);
    setSelectedImage(null);
    setSelectedFestival(null);
  };

  const navigateImage = (direction) => {
    let currentImages;
    
    if (selectedFestival && festivalImages[selectedFestival]) {
      currentImages = festivalImages[selectedFestival];
    } else {
      // If no festival selected, use all gallery images
      currentImages = galleryImages;
    }
    
    if (!currentImages || currentImages.length === 0) return;
    
    const currentIndex = currentImages.findIndex(
      (img) => img.id === selectedImage,
    );
    
    if (currentIndex === -1) return;
    
    let newIndex;
    if (direction === "next") {
      newIndex = (currentIndex + 1) % currentImages.length;
    } else {
      newIndex =
        (currentIndex - 1 + currentImages.length) % currentImages.length;
    }
    setSelectedImage(currentImages[newIndex].id);
  };

  const currentImage = selectedFestival
    ? festivalImages[selectedFestival]?.find((img) => img.id === selectedImage)
    : galleryImages.find((img) => img.id === selectedImage) || 
      // Fallback: search in all festival images if not found in galleryImages
      Object.values(festivalImages).flat().find((img) => img.id === selectedImage);

  return (
    <div className="culture-wrapper">
      {/* Unique Hero Section with Geometric Animations - Same as Team Page */}
      <section className="team-hero section-block" style={{ height: "auto" }}>
        <div className="hero-bg-animation">
          <div className="geometric-shape shape-1"></div>
          <div className="geometric-shape shape-2"></div>
          <div className="geometric-shape shape-3"></div>
        </div>
        <div className="hero-grid-lines"></div>
        <div className="container" style={{height:'350px'}}>
          <div>
            <div className="hero-badge">
              <span className="badge-icon">🌟</span>
              <span>Life at Finike Lithium</span>
            </div>
            <h1 className="hero-title" style={{fontSize:'60px'}}>
              <span style={{color:'white'}}>Empowering India's Sustainable</span><br></br>
              <span style={{color:'white'}}>Energy Future</span>
            </h1>
            <p className="hero-description" style={{color:'white'}}>
              At Finike Lithium, we foster a culture of innovation, sustainability, and excellence, 
              propelling India's clean energy transformation while celebrating our team spirit 
              and traditional values.
            </p>
          
          </div>
        </div>
      </section>

      {/* Enhanced Gallery Section */}
      <section className="gallery-section section-block">
        <div className="container">
          <div className="section-header centered">
            <div>
              <p className="eyebrow">Celebrations & Events</p>
              <h2 className="title-gradient">
                Celebrating Our Culture & Team Spirit
              </h2>
            </div>
          </div>
          <p className="section-subtitle animate-slide">
            Beyond energy solutions, we build connections, celebrate traditions,
            and grow together as one team.
          </p>

          {/* Category Filter */}
          <div className="gallery-filter animate-slide">
            {[
              { id: "all", name: "All Events", icon: "🎉" },
              { id: "diwali", name: "Diwali", icon: "🪔" },
              { id: "holi", name: "Holi", icon: "🎨" },
              { id: "lohri", name: "Lohri", icon: "🔥" },
              { id: "cricket", name: "Sports", icon: "🏏" },
              { id: "appreciation", name: "Appreciation", icon: "🏆" },
              { id: "birthday", name: "Birthday", icon: "🎂" },
            ].map((category) => (
              <button
                key={category.id}
                className={`filter-btn ${activeCategory === category.id ? "active" : ""}`}
                onClick={() => setActiveCategory(category.id)}
              >
                <span className="btn-icon">{category.icon}</span>
                {category.name}
              </button>
            ))}
          </div>

          {/* Gallery Grid */}
          <div className="gallery-grid">
            {(activeCategory === "all"
              ? galleryImages
              : festivalImages[activeCategory] || []
            ).map((image, index) => (
              <div
                key={image.id}
                className={`gallery-item animate-pop`}
                style={{ "--delay": `${index * 0.1}s` }}
                onClick={() => {
                  if (activeCategory === 'all') {
                    openGallery(image.id, image.festival);
                  } else {
                    // For specific categories, open directly with first image of that category
                    const firstImageOfCategory = festivalImages[activeCategory][0];
                    if (firstImageOfCategory) {
                      openGallery(firstImageOfCategory.id, activeCategory);
                    }
                  }
                }}
              >
                <div className="gallery-image-container surface-card">
                  <img src={image.thumbnail} alt={image.alt} />
                  <div className="gallery-overlay">
                    <div className="overlay-content">
                      <h4>{image.title}</h4>
                      <p>{image.description}</p>
                      {activeCategory === 'all' && (
                        <span className="view-btn">View Gallery →</span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Core Values Section */}
      <section className="values-section section-block">
        <div className="container">
          <div className="section-header centered">
            <div>
              <p className="eyebrow">Our Values</p>
              <h2 className="title-gradient">
                Why Professionals Choose Finike Lithium
              </h2>
            </div>
          </div>
          <p className="section-subtitle animate-slide">
            We foster an environment where purpose-driven work intersects with
            professional growth and collaborative achievement.
          </p>

          <div className="values-grid">
            {[
              {
                icon: "🎯",
                color: "#2e90fa",
                title: "Purposeful Impact",
                desc: "Contribute directly to India's sustainable energy transformation through meaningful projects.",
              },
              {
                icon: "📚",
                color: "#039855",
                title: "Professional Growth",
                desc: "Access comprehensive training programs, workshops, and career advancement opportunities.",
              },
              {
                icon: "🏆",
                color: "#f63d68",
                title: "Achievement Recognition",
                desc: "Celebrate individual and team accomplishments through our comprehensive rewards system.",
              },
              {
                icon: "🤝",
                color: "#8b5cf6",
                title: "Team Collaboration",
                desc: "Work in a collaborative environment that values diverse perspectives and collective success.",
              },
              {
                icon: "💡",
                color: "#f59e0b",
                title: "Innovation Culture",
                desc: "Be part of a culture that encourages creativity, experimentation, and breakthrough thinking.",
              },
              {
                icon: "🌱",
                color: "#10b981",
                title: "Sustainability Focus",
                desc: "Contribute to environmental stewardship through sustainable energy solutions.",
              },
            ].map((item, index) => (
              <div
                key={index}
                className={`value-card surface-card animate-pop`}
                style={{ "--delay": `${index * 0.1}s` }}
              >
                <div className="value-icon" style={{ color: item.color }}>
                  {item.icon}
                </div>
                <h3>{item.title}</h3>
                <p>{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Team Loves Working Here - Enhanced */}
      <section className="culture-notes-section section-block">
        <div className="container">
          <div className="section-header centered">
            <div>
              <p className="eyebrow">Team Experience</p>
              <h2 className="title-gradient">
                Life Beyond Work
              </h2>
            </div>
          </div>
          <p className="section-subtitle animate-slide">
            We believe in work-life integration that nurtures personal growth,
            celebrates achievements, and builds lasting relationships.
          </p>

          <div className="notes-grid">
            {[
              {
                badge: "Learning",
                title: "Continuous Learning",
                desc: "Workshops, seminars, and training programs to keep our team updated with the latest industry trends.",
              },
              {
                badge: "Celebration",
                title: "Festival Celebrations",
                desc: "Colorful celebrations of Indian festivals that bring our diverse team together and strengthen bonds.",
              },
              {
                badge: "Sports",
                title: "Sports & Recreation",
                desc: "Annual sports tournaments and recreational activities that promote teamwork and healthy competition.",
              },
            ].map((note, index) => (
              <div
                key={index}
                className={`note-card surface-card animate-pop`}
                style={{ "--delay": `${index * 0.1}s` }}
              >
                <div className="note-header">
                  <span className="note-badge">{note.badge}</span>
                </div>
                <h3>{note.title}</h3>
                <p>{note.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Enhanced Image Gallery Modal */}
      {isGalleryOpen && currentImage && (
        <div className="image-modal" onClick={closeGallery}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            {/* Close Button */}
            <button className="modal-close" onClick={closeGallery}>
              ×
            </button>

            {/* Category Badge */}
            {selectedFestival && (
              <div className="modal-category-header">
                <span className="category-badge">
                  {selectedFestival === 'diwali' && '🪔 Diwali'}
                  {selectedFestival === 'holi' && '🎨 Holi'}
                  {selectedFestival === 'lohri' && '🔥 Lohri'}
                  {selectedFestival === 'cricket' && '🏏 Sports'}
                  {selectedFestival === 'birthday' && '🎂 Birthday'}
                  {selectedFestival === 'appreciation' && '🏆 Appreciation'}
                </span>
              </div>
            )}

            {/* Horizontal Image Gallery */}
            <div className="modal-gallery-slider">
              <button 
                className="modal-gallery-nav-btn modal-prev-btn" 
                onClick={() => scrollModalGallery('left')}
              >
                ←
              </button>
              
              <div className="modal-gallery-track" ref={modalGalleryRef}>
                {(selectedFestival && festivalImages[selectedFestival]
                  ? festivalImages[selectedFestival]
                  : galleryImages
                ).map((img) => (
                  <div
                    key={img.id}
                    className={`modal-gallery-item ${selectedImage === img.id ? "active" : ""}`}
                    onClick={() => setSelectedImage(img.id)}
                  >
                    <img src={img.src} alt={img.alt} />
                    <div className="modal-image-info">
                      <h4>{img.title}</h4>
                      <p>{img.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              
              <button 
                className="modal-gallery-nav-btn modal-next-btn" 
                onClick={() => scrollModalGallery('right')}
              >
                →
              </button>
            </div>

            {/* Current Image Info */}
            <div className="modal-info">
              <h3>{currentImage.title}</h3>
              <p>{currentImage.description}</p>

              {/* Navigation */}
              <div className="modal-navigation">
                <button
                  className="nav-btn prev-btn"
                  onClick={() => navigateImage("prev")}
                >
                  ←
                </button>
                <button
                  className="nav-btn next-btn"
                  onClick={() => navigateImage("next")}
                >
                  →
                </button>
              </div>

              {/* Thumbnail Strip */}
              <div className="modal-thumbnails">
                {(selectedFestival && festivalImages[selectedFestival]
                  ? festivalImages[selectedFestival]
                  : galleryImages
                ).map((img) => (
                  <img
                    key={img.id}
                    src={img.thumbnail}
                    alt={img.alt}
                    className={`thumbnail ${selectedImage === img.id ? "active" : ""}`}
                    onClick={() => setSelectedImage(img.id)}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default OurCulture;
